module.exports = __webpack_public_path__ + "media/images/favicon-16x16-049b50c29023e0593e50c173006a64a2.png";